import { createFileRoute } from '@tanstack/react-router'
import { RegularLink } from '../../../components/inline/RegularLink'

export const Route = createFileRoute('/faq/terms/')({
  component: TermsPage,
})

function TermsPage() {
  return (
    <div className="min-h-screen flex flex-col font-sans bg-stone-50 dark:bg-mist-950 text-stone-900 dark:text-white">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <RegularLink to="/faq" className="font-medium mb-8 inline-flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to FAQ
        </RegularLink>

        <h1 className="text-4xl font-bold mb-8 text-stone-900 dark:text-white">Terms of Service</h1>

        <div className="prose prose-stone dark:prose-invert max-w-none space-y-6 text-stone-700 dark:text-stone-300">
          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">1. Agreement to Terms</h2>
            <p>
              By accessing and using Sermon Slides, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">2. Use License</h2>
            <p>Permission is granted to temporarily download one copy of the materials (information or software) on Sermon Slides for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Modifying or copying the materials</li>
              <li>Using the materials for any commercial purpose or for any public display</li>
              <li>Attempting to decompile or reverse engineer any software contained on the Service</li>
              <li>Removing any copyright or other proprietary notations from the materials</li>
              <li>Transferring the materials to another person or "mirroring" the materials on any other server</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">3. Disclaimer</h2>
            <p>
              The materials on Sermon Slides are provided on an 'as is' basis. Sermon Slides makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">4. Limitations</h2>
            <p>
              In no event shall Sermon Slides or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on the Internet site, even if Sermon Slides or a Sermon Slides authorized representative has been notified orally or in writing of the possibility of such damage.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">5. Accuracy of Materials</h2>
            <p>
              The materials appearing on Sermon Slides could include technical, typographical, or photographic errors. Sermon Slides does not warrant that any of the materials on its Internet web site are accurate, complete, or current. Sermon Slides may make changes to the materials contained on its web site at any time without notice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">6. Links</h2>
            <p>
              Sermon Slides has not reviewed all of the sites linked to its Internet web site and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Sermon Slides of the site. Use of any such linked web site is at the user's own risk.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">7. Modifications</h2>
            <p>
              Sermon Slides may revise these terms of service for its web site at any time without notice. By using this web site, you are agreeing to be bound by the then current version of these terms of service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">8. Governing Law</h2>
            <p>
              These terms and conditions are governed by and construed in accordance with the laws of the United States, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">9. Content</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>You agree that you own the rights to all content uploaded.</li>
              <li>You agree to not upload sensitive, illegal, or dangerous content.</li>
              <li>Unwritten Media reserves the right to monitor, block, or remove any content automatically or based on human review. We do not promise to catch content, and the responsibility is with the uploader.</li>
              <li>Abuse of the system is determined solely by Unwritten Media and we reserve the right to block use of the system before or after reaching out regarding the abuse, depending on the severity and urgency of the situation.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">10. Refund Policy</h2>
            <p>
              No refunds are issued for subscriptions. If you experience any issues with getting started or using Sermon Slides, please contact us first. We are committed to assisting you and have a chance to make things right.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">11. Contact Us</h2>
            <p>If you have any questions about these Terms of Service, please contact us at:</p>
            <p className="text-stone-600 dark:text-stone-400">
              Email: <RegularLink href="mailto:legal@sermon-slides.com">legal@sermon-slides.com</RegularLink>
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
